/**
 * Dismiss
 * Alerts
 * @author Oliver Boermans
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'dismiss';
const log = debug(MODULE_NAME);


//
// Utilities
// ===========

let acceptCookie = undefined;
let alertNotification = undefined;
const acceptCookieElement = document.querySelector('meta[name="config:api.acceptcookies"]');
if(acceptCookieElement) {
	acceptCookie = acceptCookieElement.content;
}

const alertNotificationElement = document.querySelector('meta[name="config:api.alertnotification"]');
if(alertNotificationElement) {
	alertNotification = alertNotificationElement.content;
}

const COOKIE_API = acceptCookie;
const ALERT_API = alertNotification;

//
// Config
// ===========
const ALERT_COOKIE_SELECTOR = "[data-alert]";
const ALERT_CUSTOM_SELECTOR = "[data-alert-custom]";
const ALERT_BUTTON_SELECTOR = 'button';

const hidePanel = function (alertToHide, otherAlert) {
	const $alertPanel = $(alertToHide);
	$alertPanel.hide();

	const $otherAlertPanel = $(otherAlert);
	if (!$otherAlertPanel.length || $otherAlertPanel.is(":hidden")){

		$('body').removeClass('has-alert');

	} else {

		$('body').removeClass('has-second-alert');

	}
};

const dismissCookieAlert = function () {
	$.get(COOKIE_API);
	hidePanel(ALERT_COOKIE_SELECTOR, ALERT_CUSTOM_SELECTOR);
};

const dismissCustomAlert = function () {
	const alertId = $(ALERT_CUSTOM_SELECTOR).data("alert-id");
	$.get(ALERT_API, {
		id: alertId
	});
	hidePanel(ALERT_CUSTOM_SELECTOR, ALERT_COOKIE_SELECTOR);
};


export default function init (){

	const alertCookieButton = $(ALERT_COOKIE_SELECTOR).find(ALERT_BUTTON_SELECTOR);
	const alertCustomButton = $(ALERT_CUSTOM_SELECTOR).find(ALERT_BUTTON_SELECTOR);

	if (alertCookieButton.length) {
		alertCookieButton.on('click',dismissCookieAlert);
	} else {
		log("No cookie site alert found.");
	}

	if (alertCustomButton.length) {
		alertCustomButton.on('click',dismissCustomAlert);
	} else {
		log("No custom site alert found.");
	}

};


// WEBPACK FOOTER //
// ./project/client/src/core/modules/alerts/dismiss.js